import { Component, EventEmitter, Input, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationType } from 'src/app/shared/app.enums';
import { InfoReportNotification } from 'src/app/shared/models/info-report-notification';
import { SystemMessage } from 'src/app/shared/models/message-model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'ness-info-report-review',
  templateUrl: './info-report-review.component.html'
})
export class InfoReportReviewComponent implements OnDestroy {
  @Output() linkClicked = new EventEmitter<number>();  
  @Input() updatedIR: ServerModels.ENESS_IntelligenceReports; 
  @Input() trackingInvalid: boolean;
  @Input() eventsLeadsInvalid: boolean;
  @Input() notesSummaryInvalid: boolean;
  @Input() trackingSubmitted: boolean;
  @Input() eventsLeadsSubmitted: boolean;
  @Input() notesSummarySubmitted: boolean;
  apiRoot: string = environment.apiEndpoint;
  trackingNotification: InfoReportNotification = { header: 'Basic Tracking information', message: '', NotificationType: NotificationType.default, TabIndex: 0 };
  eventsLeadsNotification: InfoReportNotification = { header: 'Events, NIBIN Leads, and Targets information', message: '', NotificationType: NotificationType.default, TabIndex: 1 };
  summaryNotification: InfoReportNotification = { header: 'Summary and Notes information', message: '', NotificationType: NotificationType.default, TabIndex: 2 };  
  msgs: SystemMessage[] = [];  
  submitNotification: InfoReportNotification = { header: 'Success: Information Report record created.', message: '', NotificationType: NotificationType.success, TabIndex: -1 };
  submitted: boolean = false;
  private _unsubscribe$: Subject<void> = new Subject<void>();

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  ngOnChanges(changes: SimpleChanges) {    
    if (!this.updatedIR) {      
      this.trackingNotification = { header: 'Basic Tracking information', message: 'Please review basic tracking data.', NotificationType: NotificationType.alert, TabIndex: 0 };
      this.eventsLeadsNotification = { header: 'Events, NIBIN Leads, and Targets information', message: 'Please review events, NIBIN leads, and targets information.', NotificationType: NotificationType.alert, TabIndex: 1 };
      this.summaryNotification = { header: 'Summary and Notes information', message: 'Please review summary and notes information.', NotificationType: NotificationType.alert, TabIndex: 2 };
    }
    else {      
      this.trackingNotification = { header: 'Basic Tracking information', message: '', NotificationType: NotificationType.default, TabIndex: 0 };
      this.eventsLeadsNotification = { header: 'Events, NIBIN Leads, and Targets information', message: '', NotificationType: NotificationType.default, TabIndex: 1 };
      this.summaryNotification = { header: 'Summary and Notes information', message: '', NotificationType: NotificationType.default, TabIndex: 2 };
      if (this.trackingSubmitted) {
        this.trackingNotification = { header: 'Basic Tracking information', message: '', NotificationType: NotificationType.default, TabIndex: 0 };
      }
      else {
        this.trackingNotification = { header: 'Basic Tracking information', message: 'Please review basic tracking data.', NotificationType: NotificationType.warning, TabIndex: 0 };
      }
      if (this.trackingInvalid) {
        this.trackingNotification = { header: 'Basic Tracking information', message: 'Please review basic tracking data. There are errors on the form.', NotificationType: NotificationType.alert, TabIndex: 0 };
      }
      if (this.eventsLeadsSubmitted) {
        this.eventsLeadsNotification = { header: 'Events, NIBIN Leads, and Targets information', message: '', NotificationType: NotificationType.default, TabIndex: 1 };
      }
      else {        
        this.eventsLeadsNotification = { header: 'Events, NIBIN Leads, and Targets information', message: 'Please review events, NIBIN leads, and targets information.', NotificationType: NotificationType.warning, TabIndex: 1 };
      }
      if (this.updatedIR.ENESS_XREF_IRsCrimeGuns.length == 0 || this.updatedIR.ENESS_XREF_IRsLECaseNumbers.length == 0 || this.updatedIR.ENESS_XREF_IRsPeopleTargets.length == 0) {        
        if (this.updatedIR.ENESS_XREF_IRsCrimeGuns.length == 0) {
          this.eventsLeadsNotification.message = this.eventsLeadsNotification.message + " No crime guns added.";
        }
        if (this.updatedIR.ENESS_XREF_IRsLECaseNumbers.length == 0) {
          this.eventsLeadsNotification.message = this.eventsLeadsNotification.message + " No LE case numbers added.";
        }
        if (this.updatedIR.ENESS_XREF_IRsPeopleTargets.length == 0) {
          this.eventsLeadsNotification.message = this.eventsLeadsNotification.message + " No people/targets added.";
        }
        this.eventsLeadsNotification.NotificationType = NotificationType.warning;
      } 
      if (this.eventsLeadsInvalid) {
        this.eventsLeadsNotification = { header: 'Events, NIBIN Leads, and Targets information', message: 'Please review events, NIBIN leads, and targets information. There are errors on the form.', NotificationType: NotificationType.alert, TabIndex: 1 };
      }
      if (this.notesSummarySubmitted) {
        this.summaryNotification = { header: 'Summary and Notes information', message: '', NotificationType: NotificationType.default, TabIndex: 2 };
      }
      else {
        this.summaryNotification = { header: 'Summary and Notes information', message: 'Please review summary and notes information.', NotificationType: NotificationType.warning, TabIndex: 2 };
      }      
      if (!this.updatedIR.Summary || !this.updatedIR.Notes || this.updatedIR.ENESS_XREF_IRsAttachments.length == 0) {        
        if (!this.updatedIR.Summary) {
          this.summaryNotification.message = this.summaryNotification.message + " No summary entered.";
        }
        if (!this.updatedIR.Notes) {
          this.summaryNotification.message = this.summaryNotification.message + " No notes entered.";
        }
        if (this.updatedIR.ENESS_XREF_IRsAttachments.length == 0) {
          this.summaryNotification.message = this.summaryNotification.message + " No attachments added.";
        }
        this.summaryNotification.NotificationType = NotificationType.warning;
      }
      if (this.notesSummaryInvalid) {
        this.summaryNotification = { header: 'Summary and Notes information', message: 'Please review summary and notes information. There are errors on the form.', NotificationType: NotificationType.alert, TabIndex: 2 };
      }
    }    
  }

  clickLink(tabIndex:number) {
    this.linkClicked.emit(tabIndex);
  }
}
